import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 680,
	},
	description: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
		margin: 0,
	},
});
